<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <v-card class="elevation-11">
          <v-card-text>
            <h1>Create New Songlist</h1>
            <div class="inputs">
              <v-text-field label="Songlist name" id="name" type="text" class="mb-4 mt-4" autofocus v-model.trim="name" required>
              </v-text-field>

              <v-select :items="users" v-model="user" id="users" label="Create for" class="mb-4" dense single-line menu-props="auto" required></v-select>
            </div>
            <div class="mt-5">
              <v-btn small color="secondary" @click="saveSonglist">Save</v-btn>
              <v-btn small color="ml-4" @click="cancel">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>
import { generateUUID, getIndex } from '../../mixins/utilities.js'
export default {
  mounted() {
    this.$store.state.user === null ? $router.push('login') : ""
    this.name = ''
  },
  data() {
    return {
      name: '',
      user: '',
      users: [ ...this.$store.getters.getStudentsNames],
    }
  },
  methods: {
    saveSonglist() {
      if (this.name === '') {
        alert('Please enter a songlist name!')
        document.getElementById("name").focus()
        return
      }

      if (this.user === '') {
        alert('Please choose a user!')
        document.getElementById("users").focus()
        return
      }

      const objNewSonglist = {
        name: this.name,
        user: this.user,
        songlistId: generateUUID()
      }
      this.$store.dispatch('addNewSonglist', objNewSonglist)
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.inputs {
  margin-top: 50px;
  width: 100%;
}

h1 {
  font-size: 1.5rem;
  margin-bottom: 20px;
}
</style>